export class InputData
{
  requestID:string;
  pageToken:string;

  static toURLParameters( inputData:InputData )
  { 
    let output = [];
    
    for ( let it in inputData )
    {
      if ( typeof ( inputData as any )[ it ] === "function" )
      {
        continue;
      } 

      let key   = it + "";
      let value = ( inputData as any )[ it ] + "";
      let entry = `${key}=${value}`;
      output.push( entry ); 
    }

    return output.join( "&" );
  }
}